var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showMSIOption, validateBasicInfo, validateSubCluster } from '../../utils/ComputeFormikSettingsUtils';
import _ from 'lodash';
import { ComputeType } from '../../../../../models/ComputeAbstract';
import { ClusterScale as SynapseClusterScale, DefaultNodeSize as SynapseDefaultNodeSize, getSynapseValidateMessage, } from '../SynapseSubCluster/SynapseSubClusterComponent';
import { AuthenticationType } from '../../../../constants/ComputeResource.constants';
export const SparkComputeTypeDictionary = {
    // https://experimentation.visualstudio.com/Analysis%20and%20Experimentation/_git/AnE.ExP.Nuget?path=%2FAnE.ExP.Pipeline.ComputeManagementService.Contract%2Fsrc%2FAnE.ExP.Pipeline.ComputeManagementService.Contract%2FComputeType.cs
    [ComputeType.CosmosVC]: 1,
    [ComputeType.Synapse]: 2,
    [ComputeType.BlueshiftADLA]: 4,
};
export const getSynapseResources = (synapseSubClusterList) => {
    let resources = [];
    if (synapseSubClusterList && synapseSubClusterList.length > 0) {
        resources = synapseSubClusterList.map((item) => {
            var _a, _b, _c;
            return {
                name: item.Name,
                developmentUrl: item.DevelopmentUrl,
                storageAccount: item.StorageAccount,
                storageContainer: item.StorageContainer,
                poolName: item.PoolName,
                nodeSize: item.NodeSize === SynapseDefaultNodeSize ? undefined : item.NodeSize,
                minWorkers: item.ScaleType === SynapseClusterScale.AutoScaling ? parseInt((_a = item.MinWorkers) !== null && _a !== void 0 ? _a : '1') : undefined,
                maxWorkers: item.ScaleType === SynapseClusterScale.AutoScaling ? parseInt((_b = item.MaxWorkers) !== null && _b !== void 0 ? _b : '1') : undefined,
                fixedWorkers: item.ScaleType === SynapseClusterScale.Fixed ? parseInt((_c = item.FixedWorkers) !== null && _c !== void 0 ? _c : '4') : undefined,
                maxConcurrency: parseInt(item.MaxConcurrency),
                scaleType: item.ScaleType,
                sparkVersion: item.SparkVersion,
            };
        });
    }
    return resources;
};
export const convertToComputePostParams = (props) => {
    let cosmosVC = {
        cluster: props.cluster,
        vcName: props.vcName,
        maxConcurrency: props.maxConcurrency,
    };
    let synapsePool = {
        strategy: 0,
        resources: getSynapseResources(props.synapseSubClusterList),
    };
    let adlaBlueshift = {
        adlaAccountName: props.adlaAccountName,
        maxConcurrency: props.maxConcurrency,
        defaultStorageAccountName: props.defaultStorageAccountName,
    };
    let authenticationInfo = {
        authenticationId: props.servicePrincipalName,
    };
    let postParams = {
        workspaceId: props.workspaceId,
        name: props.name,
        description: '',
        type: !props.sparkComputeType ? 0 : SparkComputeTypeDictionary[props.sparkComputeType],
        owners: props.owners,
        cosmosVC: props.sparkComputeType === ComputeType.CosmosVC ? cosmosVC : undefined,
        synapsePool: props.sparkComputeType === ComputeType.Synapse ? synapsePool : undefined,
        blueshiftADLA: props.sparkComputeType === ComputeType.BlueshiftADLA ? adlaBlueshift : undefined,
        authenticationInfo: props.sparkComputeType === ComputeType.BlueshiftADLA &&
            (!props.authenticationType || props.authenticationType === AuthenticationType.ServicePrincipal)
            ? authenticationInfo
            : undefined,
        managedIdentityId: showMSIOption(props.workspaceId) &&
            (props.sparkComputeType === ComputeType.BlueshiftADLA ||
                props.sparkComputeType === ComputeType.Synapse ||
                props.sparkComputeType === ComputeType.CosmosVC) &&
            (!props.authenticationType || props.authenticationType === AuthenticationType.ManagedIdentity)
            ? props.managedIdentityId
            : undefined,
    };
    return postParams;
};
export const ComputeCreateFormSettings = {
    mapPropsToValues: (props) => {
        return {
            workspaceId: props.workspaceId,
            name: '',
            sparkComputeType: '',
            owners: [],
            synapseSubClusterList: [],
            cluster: '',
            vcName: '',
            maxConcurrency: '',
            defaultStorageAccountName: '',
        };
    },
    validate: (values, props) => {
        let errors = {};
        errors = validateBasicInfo(values, props);
        errors = validateSubCluster(values, errors);
        return errors;
    },
    validateOnChange: true,
    validateOnBlur: true,
    handleSubmit: (values, bag) => __awaiter(void 0, void 0, void 0, function* () {
        bag.props.onSubmit &&
            bag.props.onSubmit({
                workspaceId: values.workspaceId,
                name: values.name,
                sparkComputeType: values.sparkComputeType,
                owners: values.owners,
                synapseSubClusterList: values.synapseSubClusterList,
                cluster: values.cluster,
                vcName: values.vcName,
                maxConcurrency: values.maxConcurrency,
                adlaAccountName: values.adlaAccountName,
                servicePrincipalName: values.servicePrincipalName,
                defaultStorageAccountName: values.defaultStorageAccountName,
                managedIdentityId: values.managedIdentityId,
            });
    }),
};
const getSynapseInfo = (synapseSubClusterListDefault, validation) => {
    let validationErrors = [];
    if (validation && validation.errors) {
        validation.errors.forEach((item) => {
            // Parse Resources[n]'s n
            if (item.errorPosition) {
                const Resources = item.errorPosition.match(/SynapsePool\.Resources\[\d+\]/g);
                if (Resources && Resources.length > 0) {
                    const numbers = Resources[0].match(/\d+/g);
                    if (numbers && numbers.length > 0) {
                        const n = numbers[0];
                        const pos = item.errorPosition.indexOf(Resources[0]) + Resources[0].length;
                        if (pos + 1 < item.errorPosition.length) {
                            const errorPath = item.errorPosition.substring(pos + 1);
                            const errorPathArray = errorPath.split('.');
                            const error = errorPathArray[errorPathArray.length - 1];
                            validationErrors.push({
                                postion: n,
                                errorIndex: error,
                                errorMsg: item.description,
                            });
                        }
                    }
                }
            }
        });
    }
    let result = [];
    if (synapseSubClusterListDefault && synapseSubClusterListDefault.length > 0) {
        result = synapseSubClusterListDefault.map((item, index) => {
            var _a, _b, _c, _d;
            let subCluster = {
                Name: item.name,
                DevelopmentUrl: item.developmentUrl,
                StorageAccount: item.storageAccount,
                StorageContainer: item.storageContainer,
                PoolName: item.poolName,
                MaxConcurrency: (_a = item.maxConcurrency) === null || _a === void 0 ? void 0 : _a.toString(),
                NodeSize: !item.nodeSize ? SynapseDefaultNodeSize : item.nodeSize,
                ScaleType: item.scaleType,
                MaxWorkers: (_b = item.maxWorkers) === null || _b === void 0 ? void 0 : _b.toString(),
                MinWorkers: (_c = item.minWorkers) === null || _c === void 0 ? void 0 : _c.toString(),
                FixedWorkers: (_d = item.fixedWorkers) === null || _d === void 0 ? void 0 : _d.toString(),
                SparkVersion: item.sparkVersion,
                required: {
                    Name: getSynapseValidateMessage('Name', item.name),
                    DevelopmentUrl: getSynapseValidateMessage('DevelopmentUrl', item.developmentUrl),
                    StorageAccount: getSynapseValidateMessage('StorageAccount', item.storageAccount),
                    StorageContainer: getSynapseValidateMessage('StorageContainer', item.storageContainer),
                    PoolName: getSynapseValidateMessage('PoolName', item.poolName),
                    MaxConcurrency: !!item.maxConcurrency ? '' : 'Required',
                    ScaleType: getSynapseValidateMessage('ScaleType', item.scaleType),
                    FixedWorkers: !!item.fixedWorkers && item.scaleType === SynapseClusterScale.Fixed ? '' : 'Required',
                    MinWorkers: !!item.minWorkers && item.scaleType === SynapseClusterScale.AutoScaling ? '' : 'Required',
                    MaxWorkers: !!item.maxWorkers && item.scaleType === SynapseClusterScale.AutoScaling ? '' : 'Required',
                    SparkVersion: getSynapseValidateMessage('SparkVersion', item.sparkVersion),
                },
            };
            _.each(validationErrors, (item) => {
                if (index.toString() === item.postion) {
                    subCluster.required[item.errorIndex] = item.errorMsg;
                }
            });
            return subCluster;
        });
    }
    return result;
};
export const ComputeEditFormSettings = {
    mapPropsToValues: (props) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        const data = props.defaultCompute;
        return {
            name: data.name,
            sparkComputeType: (_a = data.config) === null || _a === void 0 ? void 0 : _a.type,
            owners: (_b = data.config) === null || _b === void 0 ? void 0 : _b.owners,
            synapseSubClusterList: getSynapseInfo((_e = (_d = (_c = props.defaultCompute) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.synapsePool) === null || _e === void 0 ? void 0 : _e.resources, data.validation),
            cluster: (_g = (_f = data.config) === null || _f === void 0 ? void 0 : _f.cosmosVC) === null || _g === void 0 ? void 0 : _g.cluster,
            vcName: (_j = (_h = data.config) === null || _h === void 0 ? void 0 : _h.cosmosVC) === null || _j === void 0 ? void 0 : _j.vcName,
            maxConcurrency: ((_k = data.config) === null || _k === void 0 ? void 0 : _k.cosmosVC)
                ? (_o = (_m = (_l = data.config) === null || _l === void 0 ? void 0 : _l.cosmosVC) === null || _m === void 0 ? void 0 : _m.maxConcurrency) === null || _o === void 0 ? void 0 : _o.toString()
                : (_r = (_q = (_p = data.config) === null || _p === void 0 ? void 0 : _p.blueshiftADLA) === null || _q === void 0 ? void 0 : _q.maxConcurrency) === null || _r === void 0 ? void 0 : _r.toString(),
            adlaAccountName: (_t = (_s = data.config) === null || _s === void 0 ? void 0 : _s.blueshiftADLA) === null || _t === void 0 ? void 0 : _t.adlaAccountName,
            servicePrincipalName: (_v = (_u = data.config) === null || _u === void 0 ? void 0 : _u.authenticationInfo) === null || _v === void 0 ? void 0 : _v.authenticationId,
            defaultStorageAccountName: (_x = (_w = data.config) === null || _w === void 0 ? void 0 : _w.blueshiftADLA) === null || _x === void 0 ? void 0 : _x.defaultStorageAccountName,
            managedIdentityId: (_y = data.config) === null || _y === void 0 ? void 0 : _y.managedIdentityId,
        };
    },
    validate: (values, 
    /**
     * TODO - do these interfaces need to be unique?
     * IComputeSummaryProps & IComputeCreateFormComponentProps
     */
    props) => {
        let errors = {};
        errors = validateBasicInfo(values, props);
        errors = validateSubCluster(values, errors);
        return errors;
    },
    validateOnChange: true,
    validateOnBlur: true,
    handleSubmit: (values, bag) => __awaiter(void 0, void 0, void 0, function* () {
        bag.props.savePanel && bag.props.savePanel(values);
    }),
};

//# sourceMappingURL=ComputeCreateFormSettings.js.map
